const ModelLocalizer = require('./model-localizer');

const CATEGORY_L10N_MAP = [['name', 'nameLocalized'], ['shortName', 'shortNameLocalized']];

module.exports = locales => new ModelLocalizer({
  locales,
  fieldMapping: CATEGORY_L10N_MAP
});